// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-search-tooltip span{color:#fff}.cvat-search-tooltip q{margin:0 1em 0 1em}.cvat-search-tooltip strong::after{content:\" - \"}", ""]);
// Exports
module.exports = exports;
